// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"styles_errorMsg__-kVcD"};